import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import T from '@prisjakt/ui-translate';
import FlipClock from '@prisjakt/ui-flip-clock';
import NewsletterSignup from '@prisjakt/ui-newsletter-signup';
import { DAILY_DEALS_ID } from '../../../../globals/helpers/campaign/campaign-ids';
import ErrorBoundary from '../../../../components/error-boundary';

import PopularStores from '../popular-stores';
import ProductAlertBox from '../product-alert-box';
import CampaignArticles from '../campaign-articles';

import { GutterWrapper } from '../../styles';

import './index.scss';

const styles = bemGenerator('campaign-inactive', [
  'main',
  'form',
  'timer',
  'signup',
]);

class CampaignInactive extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  getPrivacyUrl() {
    const { market, renderMode } = this.context;
    return (
      market.privacySettings[renderMode] || market.privacySettings.responsive
    ).privacyUrl;
  }

  render() {
    const { t, renderMode } = this.context;
    const { campaign, targetDate, dailyDeals, router } = this.props;
    const { articles } = campaign;
    const featuredArticle = articles
      ? articles.find(item => item.featured)
      : null;
    const upcoming = campaign.state === 'UPCOMING';
    const legacyRenderMode = ['desktop', 'mobile', 'native'].includes(
      renderMode
    );

    return (
      <React.Fragment>
        <GutterWrapper>
          {!legacyRenderMode && (
            <div className={styles.main}>
              <ProductAlertBox
                campaignName={campaign.name}
                page={this.props.page}
              />
            </div>
          )}

          {upcoming && (
            <div className={styles.main}>
              <div className={styles.timer}>
                <FlipClock
                  targetDate={targetDate}
                  daysLabel={t('common', 'time.day', { n: 0 })}
                  hoursLabel={t('common', 'time.hour', { n: 0 })}
                  minutesLabel={t('common', 'time.minute', { n: 0 })}
                  secondsLabel={t('common', 'time.second', { n: 0 })}
                />
              </div>

              <div className={styles.signup}>
                <NewsletterSignup
                  title={t('campaigns', 'newsletter.sign-up-title', {
                    campaignName: campaign.name,
                  })}
                  description={t('campaigns', 'newsletter.sign-up-description')}
                />
              </div>
            </div>
          )}
        </GutterWrapper>

        <ErrorBoundary onError={() => null}>
          <CampaignArticles
            featuredArticle={featuredArticle}
            articles={articles}
            campaignName={campaign.name}
          />
        </ErrorBoundary>
        <PopularStores
          dailyDeals={dailyDeals}
          campaignId={DAILY_DEALS_ID}
          router={router}
        />
        {!upcoming && (
          <div className={styles.main}>
            <h2>
              <T domain="campaigns" campaign={campaign.name}>
                ended.title
              </T>
            </h2>
            <h3>
              <T domain="campaigns">ended.subtitle</T>
            </h3>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const { string, number, shape, object } = PropTypes;

CampaignInactive.propTypes = {
  targetDate: number.isRequired,
  page: object.isRequired,
  campaign: shape({
    title: shape({
      short: string,
      long: string,
    }),
    description: shape({
      short: string,
      long: string,
    }),
  }).isRequired,
  history: shape({
    location: shape({
      pathname: string,
      search: string,
    }),
  }).isRequired,
  router: shape({
    id: number,
  }).isRequired,
  dailyDeals: object, // eslint-disable-line react/forbid-prop-types
};

CampaignInactive.defaultProps = {
  dailyDeals: undefined,
};

CampaignInactive.contextType = AppContext;

export default withRouter(CampaignInactive);
